import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressHeaderComponent } from './progress-header.component';
import { ProgressHeaderTopItemComponent } from './progress-header-top-item/progress-header-top-item.component';
import { ProgressHeaderBottomItemComponent } from './progress-header-bottom/progress-header-bottom-item/progress-header-bottom-item.component';
import { ProgressHeaderBottomItemValueComponent } from './progress-header-bottom/progress-header-bottom-item/progress-header-bottom-item-value/progress-header-bottom-item-value.component';
import { ProgressHeaderBottomComponent } from './progress-header-bottom/progress-header-bottom.component';
import { ProgressHeaderBottomItemLabelComponent } from './progress-header-bottom/progress-header-bottom-item/progress-header-bottom-item-label/progress-header-bottom-item-label.component';

// Don't import this module directly. Instead, import LayoutSharedModule
@NgModule({
  declarations: [
    ProgressHeaderComponent,
    ProgressHeaderTopItemComponent,
    ProgressHeaderBottomComponent,
    ProgressHeaderBottomItemComponent,
    ProgressHeaderBottomItemValueComponent,
    ProgressHeaderBottomItemLabelComponent,
  ],
  imports: [CommonModule],
  exports: [
    ProgressHeaderComponent,
    ProgressHeaderTopItemComponent,
    ProgressHeaderBottomComponent,
    ProgressHeaderBottomItemComponent,
    ProgressHeaderBottomItemValueComponent,
    ProgressHeaderBottomItemLabelComponent,
  ],
})
export class ProgressHeaderModule {}
